import i18n from '@/i18n'

export const goToLanding = () => {
  const { origin, search } = window.location
  const locale = i18n.locale
  let url = `${origin}/${locale}/insurance-renewal`

  const currentParams = new URLSearchParams(search)

  if ([...currentParams].length > 0) {
    url += `?${currentParams}`
  }
  window.location.href = url
}
